const map = {
	"./Ireland-animation.png": 4917,
	"./Thankyou-Animation.gif": 2738,
	"./australia-animation.png": 8370,
	"./australia.png": 2191,
	"./canada-animation.png": 2090,
	"./canada.png": 8023,
	"./college-icon.png": 2310,
	"./error_404.png": 4786,
	"./home.png": 9844,
	"./home.svg": 1046,
	"./info.png": 1773,
	"./ireland.png": 7480,
	"./left_img.png": 6638,
	"./logo-blue.svg": 2035,
	"./logo-white.svg": 6182,
	"./logo.png": 7284,
	"./medical-bg-img.jpg": 776,
	"./medical-bg-new-img.jpg": 7377,
	"./medical-bg1.jpg": 8829,
	"./school-left-img.png": 2933,
	"./sponsered.png": 942,
	"./studyabroad-thankyou-desktop.gif": 2477,
	"./studyabroad-thankyou-mobile.gif": 8673,
	"./thankyou-school.png": 27,
	"./uk-animation.png": 5732,
	"./unitedkingdom.png": 6165,
	"./unitedstatesofamerica.png": 5885,
	"./usa-animation.png": 1461,
	"./world_map.png": 8642
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3193;